import VersioningUtil from "@/utils/versionUtil";

export type DeviceType = "AndroidReceiver" | "Room" | "iOS" | "Unknown";
export interface DeviceConfiguration {
  deviceConfigurationId: string;
  deviceId: string;
  deviceName: string;
  deviceDescription: string;
  installedProduct: string;
  installedVersion: string;
  releaseType: string;
  licenseKey?: string;
  status: string;
  releaseChannel: string;
  tenantCode: string;
  label: string;
  licensePackageId?: string;
  // webWizardConfig?: string;
  clientConfig: any; //todo: add a stronger type see below
  deviceType?: DeviceType;
  isEssential: boolean;
  sessionId: string;
  deviceDisplayMode: number;
}

//   "clientConfig": {
//    serial: string,
// "WizardSetting": {
//     "Calendar": {
//     },
//     "VideoCall": {
//     }
// }
//   "monitors": [
//     {
//       "name": "Monitor 1"
//     },
//   ]
// }

const minAndroidVersion = "0.17.25";

export const DeviceConfigurationDeserializer = (
  /* eslint-disable-next-line  @typescript-eslint/explicit-module-boundary-types */
  input: any,
  type: "AndroidReceiver" | "Room" | "iOS",
  sessionId: string,
  displayMode: number | undefined,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  webWizardStepConfig: any
): DeviceConfiguration => {
  const isOldAndroidVersion =
    type == "AndroidReceiver" &&
    !VersioningUtil.isSecondVersionHigher(
      minAndroidVersion,
      input.installedVersion || ""
    );
  const clientConfig = input.clientConfig || {};
  clientConfig.wizardSetting = clientConfig.wizardSetting || {};
  if (isOldAndroidVersion) {
    clientConfig.wizardSetting.display = undefined;
    clientConfig.wizardSetting.calendar =
      clientConfig.wizardSetting?.calendar ?? {};
    clientConfig.wizardSetting.videoCall =
      clientConfig.wizardSetting?.videoCall ?? {};
  } else {
    clientConfig.wizardSetting.display = webWizardStepConfig?.display;
  }

  const deviceDisplayMode =
    clientConfig?.wizardSetting?.display?.displayModeHint ?? displayMode ?? 0;
  return {
    deviceConfigurationId: input.deviceConfigurationId || "",
    deviceId: input.deviceId || "",
    deviceName: input.deviceName || "",
    deviceDescription: input.deviceDescription || "",
    installedProduct: input.installedProduct || "",
    installedVersion: input.installedVersion || "",
    releaseType: input.releaseType || "",
    licenseKey: input.licenseKey,
    status: input.status || "",
    releaseChannel: input.releaseChannel || "",
    tenantCode: input.tenantCode || "",
    label: input.label || "",
    licensePackageId: input.licensePackageId,
    // webWizardConfig: input.webWizardConfig,
    clientConfig: clientConfig,
    deviceType: type ? type : "Unknown",
    isEssential: input.isEssential || false,
    sessionId: sessionId,
    deviceDisplayMode,
  };
};

export interface DeviceUpdates {
  latestVersion: string;
  fileHash: string;
  downloadUrl: string;
}

/* eslint-disable-next-line  @typescript-eslint/explicit-module-boundary-types */
export const DeviceUpdatesDeserializer = (input: any): DeviceUpdates => {
  return {
    latestVersion: input.latestVersion || "",
    fileHash: input.fileHash || "",
    downloadUrl: input.downloadUrl || "",
  };
};
